import axios from "config/axios"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {useEffect, useCallback} from "react"
import {useDispatch} from "react-redux"
import {useApiDefaults} from "./useApiDefaults"
import {
  fetchCustomerAddressList,
  fetchCustomerAddressListSuccess,
} from "redux/actions"
import { ReactQueryKeys } from 'config/constant'

export function useGetCustomerAddressList(enabled = true) {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const apiDefaults = useApiDefaults()

  const getData = async () => {
    try {
      const data = await axios.post("/AogCustomerAddressList", apiDefaults)
      return data?.data?.data || []
    } catch (error) {
      console.error('❌ Error fetching customer address list:', error)
      return []
    }
  }

  const queryKey = [ReactQueryKeys.CUSTOMER_ADDRESS_LIST, apiDefaults]

  const {
    data: customerAddressList = [],
    isLoading: customerAddressListLoading,
    refetch: refetchCustomerAddressList,
  } = useQuery({
    queryKey,
    queryFn: getData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled,
  })

  const prefetchAddresses = useCallback(async () => {
    const cached = queryClient.getQueryData(queryKey)
    const cacheEmpty = cached == null || (Array.isArray(cached) && cached.length === 0)
    if (cacheEmpty) {
      return refetchCustomerAddressList()
    }
    return Promise.resolve({data: cached})
  }, [queryClient, queryKey, refetchCustomerAddressList])

  useEffect(() => {
    if (customerAddressListLoading) {
      dispatch(fetchCustomerAddressList())
    }
  }, [customerAddressListLoading, dispatch])

  useEffect(() => {
    if (customerAddressList.length) {
      dispatch(fetchCustomerAddressListSuccess(customerAddressList))
    }
  }, [customerAddressList, dispatch])

  return {
    customerAddressList,
    customerAddressListLoading,
    refetchCustomerAddressList,
    prefetchAddresses,
  }
}
